<template>
    <div class="message-widget">
      <div class="message-widget__title">{{$store.getters.language.have_a_question}}</div>
      <template v-if="sent_alert">
        <div class="message-widget__alert">{{ sent_alert }}</div>
      </template>

      <template v-else>
      <div class="message-widget__description">{{ placeholder_message }}</div>

      <div class="message-widget__wrap">
      <textarea v-model="message" :placeholder=$store.getters.language.enter_your_message_here></textarea>
        <div class="message-widget__buttons">
          <uploadcare :publicKey="'9a03fd67d6a14f6d72f9'"
                      :crop="'free'"
                      :imagesOnly="false"
                      :multiple="false"
                      @groupProgress="onUploadProgress"
                      @progress="onUploadProgress"
                      @success="onUploadSuccess"
                      @error="onUploadError">

              <button class="message-widget__upload-button" v-if="!uploads">
                <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.8398 15.0008L16.4291 9.10411C15.6128 7.10357 14.1109 7.02291 13.102 8.92664L11.6463 11.6774C10.907 13.0729 9.52836 13.1939 8.57335 11.9436L8.40391 11.7177C7.41038 10.4109 6.00866 10.5722 5.2924 12.0646L3.96769 14.8476C3.03578 16.7836 4.38359 19.0664 6.44766 19.0664H16.2751C18.2776 19.0664 19.6254 16.9288 18.8398 15.0008ZM7.5105 7.77311C8.12329 7.77311 8.71099 7.51814 9.14429 7.0643C9.5776 6.61047 9.82103 5.99493 9.82103 5.35311C9.82103 4.71128 9.5776 4.09575 9.14429 3.64191C8.71099 3.18807 8.12329 2.93311 7.5105 2.93311C6.89771 2.93311 6.31002 3.18807 5.87671 3.64191C5.44341 4.09575 5.19998 4.71128 5.19998 5.35311C5.19998 5.99493 5.44341 6.61047 5.87671 7.0643C6.31002 7.51814 6.89771 7.77311 7.5105 7.77311Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="0.5" y="0.5" width="21" height="21" rx="3.5" stroke="#4D4D4D"/>
                </svg>
              </button>
          </uploadcare>
          <button @click.prevent="sendMessage" class="message-widget__button">
            {{$store.getters.language.send}}
          </button>
        </div>

          <div class="message-widget__loader" v-if="loader">
            Uploading...
          </div>
          <div class="message-widget__files" v-if="uploads">
           <div class="message-widget__file">{{ uploads.name }}</div> <a href="#" @click.prevent="uploads = null">Remove</a>
          </div>
      </div>
    </template>
    </div>
</template>

<script>
import Uploadcare from 'components/UploadCare.vue'
import axios from 'axios'

export default {
  name: 'MessageWidget',
  data: () => ({
    loader: false,
    message_sent: false,
    uploads: null,
    message: null,
    placeholder_message: '',
    sent_alert: null
  }),
  props: {
    id: {
      default: null,
      type: String
    },
    source_type: {
      default: null,
      type: String
    },
    is_poster: {
      default: null,
      type: Boolean
    },
    receiver: {
      default: null,
      type: Number
    },
    sender: {
      default: null,
      type: Number
    }
  },
  components: {
    Uploadcare
  },
  mounted () {
      if (this.is_poster){
          this.placeholder_message = "Send a message here for more information on the poster you would like to rent."
      }else{
          this.placeholder_message = this.$store.getters.language.message_fill
      }

  },
  methods: {
    onUploadProgress (event) {
      if (event.state === "uploading") {
        this.loader = true
      } else {
        this.loader = false
      }
    },
      openIntercomChat() {
        // Gather any context data you want to send (e.g., current page, user info)
        const currentPage = window.location.href;
        const referrerPage = document.referrer;

        // Open the Intercom chat and send background context
        if (window.Intercom) {
          window.Intercom('show'); // Open the messenger

          // Send context data to Intercom
          window.Intercom('update', {
            // You can add any custom attribute here for support team reference
            last_viewed_page: currentPage,
            referrer: referrerPage,
            // You can also send user-related attributes if available
            user_id: '122', // Example of sending user ID if you have it
          });
        }
      },
    onUploadSuccess (data) {
      this.uploads = data
    },
    onUploadError () {

    },
    sendMessage () {

        var data = {
        content: this.message,
        listing_id: this.id,
        file_url: this.uploads ? this.uploads.cdnUrl : null,
        sender_id: this.sender,
        receiver_id: this.receiver,
        source_type: this.source_type,
      }

      axios.post('/messages',
      data,
      { headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': document.head.querySelector("[name=csrf-token]").content
          }
      }).then(response => {
        this.message_sent = true
        this.sent_alert = this.$store.getters.language.sent_to_manager
        this.message = null
      
      setTimeout(() => {
        this.sent_alert = null
      }, 5000)
    })
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.message-widget {
  width: 100%;
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;

  @include breakpoint(tablet) {
    margin: 0;
  }

  textarea {
    width: 100%;
    aspect-ratio: 2.8/1;
    outline: none;
    resize: none;
    @include responsive-text-size('Body--16--Light');
    padding: 16px 16px 50px 16px;
    border: 0px;
    color: #7A7A7A;
    border-radius: 4px;
    @include placeholder {
      color: $primary-grey;
    }
  }
}

.message-widget__alert {
  @include responsive-text-size('Body--16--Light');
  margin-bottom: 20px;
  padding: 10px;
  background: $primary;
  @include responsive-text-size('Header--13--BOLD');
  color: $white;
}

.message-widget__wrap {
  position: relative;
}

.message-widget__title {
  width: 100%;
  display: block;
  @include responsive-text-size('Header--13--BOLD');
  padding-bottom: 16px;
  margin-bottom: 19px;
  border-bottom: 1px solid $divider-dark;
}

.message-widget__description {
  @include responsive-text-size('Body--14--Light');
  margin-bottom: 20px;
} 

.message-widget__files {
  font-size: 14px;
  color: $primary;
  display: flex;
  position: absolute;
  bottom: -20px;
  left: 16px;
  max-width: 100%;

  a {
    margin-left: 5px;
    text-decoration: underline;
  }
}

.message-widget__upload-button {
  width: 24px;
  line-height: 1;
  svg {
    width: 100%;
  }
}

.message-widget__file {
  max-width: 120px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.message-widget__buttons {
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  padding: 10px 16px 16px 16px;
  display: flex;
  gap: 5px;
  line-height: 1;
  background: #FFFFFF;
  justify-content: space-between;
  align-items: flex-end;
}

.message-widget__loader {
  position: absolute;
  bottom: 20px;
  left: 20px;
  @include responsive-text-size('Body--14--Light');
}

.message-widget__button {
  width: 80px;
  height: 29px;
  color: $primary-grey;
  border: 1px solid $primary-grey;
  border-radius: 4px;
  text-align: center;
  background: transparent;
  @include responsive-text-size('Button--10--BOLD');
}



</style>
